import React from 'react';
import {useNavigate} from "react-router-dom";
import {useAuth} from "context/AuthContext";
import Dropdown, {DropdownItem} from "components/Dropdown";
import {PencilIcon, TrashIcon} from "@heroicons/react/solid";
import {Building} from "../../../types/Building";
import FeatureFlag from "../../../types/FeatureFlag";

// Types ----

type BuildingContextMenuProps = {
  building: Building
  onDelete: () => void
  editDisabled?: boolean
  deleteDisabled?: boolean
  position?: 'left' | 'right'
}

// Component ----

function BuildingContextMenu({building, onDelete, editDisabled, deleteDisabled, position = 'left'}: BuildingContextMenuProps) {
  const navigate = useNavigate();
  const {can, canUse} = useAuth();

  const canEditBuilding = can('buildings:write') && canUse(FeatureFlag.IndoorMapping);
  const canDeleteBuilding = can('buildings:write') && canUse(FeatureFlag.IndoorMapping);

  function editBuilding() {
    void navigate(`/buildings/${building.id}/edit`)
  }

  return (
    <Dropdown position={position}>
      {canEditBuilding &&
        <DropdownItem
          name="Edit"
          icon={PencilIcon}
          onClick={editBuilding}
          disabled={!!editDisabled}
        />
      }

      {canDeleteBuilding &&
        <DropdownItem
          name="Delete"
          icon={TrashIcon}
          onClick={onDelete}
          disabled={!!deleteDisabled}
        />
      }
    </Dropdown>
  );
}

export default BuildingContextMenu;